//My namespace
if ((typeof FpvFaster) === 'undefined') { 
  var isMobile = false; //initiate as false
  // device detection
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

  FpvFaster = {
    msPerDay: 1000 * 60 * 60 * 24,
    monthNames: ["January", "February", "March", "April", "May", "June",
                 "July", "August", "September", "October", "November", "December"
                ],
    Time: {
      // a and b are javascript Date objects
      dateDiffInDays: function(a, b) {
        // Discard the time and time-zone information.
        var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / FpvFaster.msPerDay);
      },
  
      toShortDate: function(date, includeDayOfWeek = false) {
        var crossYear = date.getFullYear() > new Date().getFullYear();
        var day = date.getDate();
        var month = FpvFaster.monthNames[date.getMonth()];
        var formattedDate = `${date.getDate()} ${month}`;
      
        if (includeDayOfWeek) {
          const weekDayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
          formattedDate = `${weekDayNames[date.getDay()]}, ${formattedDate}`;
        }
      
        if (date.getFullYear() > new Date().getFullYear()) {
          formattedDate += ` ${date.getFullYear()}`;
        }
      
        return formattedDate;
      }
    },
    
    Product: {
      onAddItemError: [],
      onPhotoSwitched: [],
    },
    
    Cart: {
      onBeforeAddItem: [],
      onUpdated: [],
      onShown:[],
      onHidden:[]
    },
    
    formatMoney: function(cents) {     
      if (isNaN(cents) || cents == null) {
        return 0;
      }
      
      var number = (cents/100.0).toFixed(2);
      var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ','),
        cents   = parts[1] ? ('.' + parts[1]) : '';

      return dollars + cents;
    },
    
    PopupStatus : function (container, popup, revealTimeout, fadeoutTimeout, showDuration) {
      var $container = container;
      var $popup = popup;
      var showing = false;
      var timerClick = null;
      var timerHover = null;
      var timerSelect = null;
      var fadeInTimeout = revealTimeout > 0 ? revealTimeout : 100;
      var fadeOutTimeout = fadeoutTimeout > 0 ? fadeoutTimeout : 100;
      
      function show() {
        if(!showing) {
          popup.fadeIn();
          showing = true;
        }
      }
      
      function toggle(){
        if(showing) {
          hide();
        } else {
          show();
        }
      }
      
      function hide() {
        if(showing) {
          $popup.fadeOut();
          showing = false;
        }
      }
      
      $(window).click(function() {
        if (showing) {
          hide();
        }
      });
      
      $popup.hover(
        function() {
          clearTimeout(timerSelect);
        }, function() {
          timerSelect = setTimeout(function() {
            hide();
          }, fadeOutTimeout);
          clearTimeout(timerHover);
          clearTimeout(timerSelect);
        }
      );
      
      $container.hover(
        function() {
          timerHover = setTimeout(function() {
            show();
          }, fadeInTimeout);
        }, function() {
          timerSelect = setTimeout(function() {
            hide();
          }, fadeOutTimeout);
          clearTimeout(timerHover);
        }
      );
      
      $container.click(function() {
        clearTimers();
        show();
        event.stopPropagation();
        
        if (isMobile && showing) {
          timerClick = setTimeout(function() {
            hide();
            clearTimers();
          }, showDuration > 0 ? showDuration : 3000);
        }
      });
      
      function clearTimers() {
        clearTimeout(timerHover);
        clearTimeout(timerSelect);
        clearTimeout(timerClick);
      }
    },

    etaDispaly: (dateTime) = {
    
    },

    Oversell: {
      updateProductView: function(variantAvailable, variantMeta, soldOut) {
        $("#availabilityStatus").css("visibility", "visible");
        $("#same-day-dispatch-info").hide();
        $("#oversell-box").html("");
        $(".delivery-info-pickup").show();
        $("#delivery-eta-after-dispatch-info").hide();

        const showOversellExtraMetaView = function() {
          $("#oversell-box").append('<hr style="margin-top: 5px; margin-bottom: 5px;" />');
          $("#delivery-eta-after-dispatch-info").show();
        };

        
        
        if (variantAvailable) {
          if (!variantMeta?.meta) {
            const oversell = variantMeta.os;
            
            $(".delivery-info-pickup").hide();
            $("#stockInfo").html("");
            $(".delivery-info-dispatch").html('Preorder items will be dispatched once they are recieved, then');

            const inStockColor = "#1ba100"
            const osType = oversell.t;
            if (osType === "pr") {
              $(".addToCartText").html("PRE-ORDER");

              $("#stockInfo").append("<span style='color:#ff4d01'><strong>Pre-order</strong></span>");
              $("#oversell-box").append("<div>Pre-ordered items will be dispatched once received in our warehouse on the same business day.</div>");

              const preOrderEta = oversell.poe;
              if (preOrderEta) {
                var time = new Date(preOrderEta);

                if (time.getTime() > new Date().getTime()) {
                  var timeFormatted = FpvFaster.Time.toShortDate(time);
                  $("#oversell-box").append("<div>Estimated Dispatch: <span style='color:#1ba100'><strong>" + timeFormatted + "</strong></span></div>");
                }
              }
              showOversellExtraMetaView();
            } else if (osType === "bo") {
              $(".addToCartText").html("BACK ORDER");
              
              $("#stockInfo").append("<span style='color:#1E90FF'><strong>Backorder</strong></span>");
              $("#oversell-box").append("<div>Back-ordered items will be dispatched once received from suppliers.</div>");
              showOversellExtraMetaView();
            } else if (osType === "as") {
              const ldt = oversell.ldt? (oversell.ldt / 86400): undefined;
              const ct = oversell.ct;

              const now = new Date();
              let cutOffMissed = false;
              if (ct) {
                //is now later then ct
                const nowSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
                const [hours, minutes, seconds] = ct.split(":").map(Number);
                const ctSeconds = hours * 3600 + minutes * 60 + seconds;
                if (nowSeconds > ctSeconds) {
                  cutOffMissed = true;
                }
              }

              if (ldt) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const actualLd = cutOffMissed? ldt + 1: ldt;
                
                // Calculate the estimated dispatch day, skipping weekends
                const estimateDispatchDay = new Date(today.getTime() + actualLd * 24 * 60 * 60 * 1000);
                
                let dispatchBizDays = 0;
                let ldtLeft = actualLd;
                let etaCountDown = estimateDispatchDay;
                while (ldtLeft > 0) {
                  etaCountDown = new Date(etaCountDown.getTime() - 86400000);
                  const dayOfWeek = etaCountDown.getDay();
                  if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Skip Sunday (0) and Saturday (6)
                     dispatchBizDays++;
                  }
                  ldtLeft--;
                }
                
                if (dispatchBizDays < 4) {
                   
                  if (oversell.si === 286250760) {
                    $("#stockInfo").append("<span style='color:#009688'><strong>At Supplier</strong></span>");
                  } else {
                    $("#stockInfo").append(`<span style='color:${inStockColor}'><strong>In Stock (Delivery Only)</strong></span>`);
                  }
                } else {
                  $("#stockInfo").append("<span style='color:#009688'><strong>At Supplier</strong></span>");
                }
                
                $("#oversell-box").append(`<div>Estimated dispatch <strong><span style='color:#1ba100'> on ${FpvFaster.Time.toShortDate(estimateDispatchDay, true)}</span></strong>.</div>`);
                if (oversell.si === 286250760) {
                  $("#oversell-box").append("<div style='color:#cc7f57'>If dispatch delays exceed your expectations, feel free to contact us for a refund.");
                }
              } else {
                $("#stockInfo").append("<span style='color:#009688'><strong>At Supplier</strong></span>");
                $("#oversell-box").append("<div>Orders with this item will be <strong><span style='color:#1ba100'>dispatched in 2-7</span></strong> days.</div>");
              }
              
              showOversellExtraMetaView();
            } else if (osType === "") {
              $("#availabilityStatus").css("visibility", "hidden");
            } else {
              $("#availabilityStatus").css("visibility", "hidden");
            }
          } else {
            $("#stockInfo").html("<span style='color:#1ba100'><strong>In Stock</strong></span>");
            $("#same-day-dispatch-info").show();
          }
        } else {
          $(".addToCartText").html(soldOut);
          $("#addToCart").attr("disabled", true);
          $("#oversell-box").html("");
          $("#stockInfo").html("Out of Stock");
        }
      }
    },
    
    Coupon: {
      updateProductView: function(isVariantAvailable, coupon) {  
        $("#coupon-pop-name").html(coupon.name);
        if (coupon.message) {
          	$("#coupon-pop-message").html(coupon.message);
        }

        var expiryDate = new Date(coupon.expiry);
        if (coupon.expiry) {
            var timeFormatted = FpvFaster.Time.toShortDate(expiryDate);
            $("#coupon-pop-expiry").html("Expires on " + timeFormatted);
        }
        
        if (Cookies.get('coupon-' + coupon.id)){
          $("#coupon-pop-code").html(coupon.code);
        } else {
          $("#coupon-pop").on('click', function() {
            ga('send', {
              hitType: 'event',
              eventCategory: 'Reveal Coupon',
              eventAction: 'Click',
              eventLabel: 'Promotion'
            });
            var days = FpvFaster.Time.dateDiffInDays(new Date(), expiryDate);
            
            Cookies.set('coupon-' + coupon.id, 'set', { expires: days, path: '' });
            $("#coupon-pop-code").html(coupon.code);
            $("#coupon-pop").unbind('click');
          });
        }
      }
    },
    
    Shipping: {
//       estimate: function(destPostcode, onSuccess, onError) {
//         var params = {
//           type: 'GET',
//           url: '//digitalapi.auspost.com.au/postage/v4/catalogue/service.json?category=DOMESTIC&from=2000&to=' + destPostcode,
//           crossDomain: true,
//     	  dataType: 'json',
//           headers: {
//             'AUTH-KEY': '62b9613ddab3f8cdaf89c47c0234729e'
//           },
//           success: function(data) {
//             onSuccess(data);
//           },
//           error: function(XMLHttpRequest, textStatus) {
//             if ((typeof onError) === 'function') {
//               onError(XMLHttpRequest, textStatus);
//             } else {
//               Shopify.onError(XMLHttpRequest, textStatus);
//             }
//           }
//         };
  
//         jQuery.ajax(params);
      
      	estimate: function(destPostcode, onSuccess, onError) {
//           var params = {
//             type: 'OPTIONS',
//             url: '//digitalapi.auspost.com.au/postage/v4/catalogue/service.json?category=DOMESTIC&from=2000&to=' + destPostcode,

//             headers: {
//                 'crossDomain': true,
//             	'Access-Control-Request-Headers': 'auth-key',
//             	'Access-Control-Request-Method': 'GET',
//             },

//             success: function(data) {
//               onSuccess(data);
//             },
//             error: function(XMLHttpRequest, textStatus) {
//               if ((typeof onError) === 'function') {
//                 onError(XMLHttpRequest, textStatus);
//               } else {
//                 Shopify.onError(XMLHttpRequest, textStatus);
//               }
//             }
//           };
//           jQuery.ajax(params);
     	}
	},
    
    Currency:{
      reRenderCurrencyDropdown: function(){
        
        
         function reRenderSelectElement(currencyCode){
               var parent = document.querySelector('.shopify-currency-form select'),
              docFrag = document.createDocumentFragment(),
              list = document.createElement('ul');
              list.setAttribute('id', 'fpvFaster-new-shopify-currency-form-ul');

                if(parent !== null){
                  // build list items
                  while(parent.firstChild) {
                      // we simultaniously remove and store the node
                      var option = parent.removeChild(parent.firstChild);

                      // not interested in text nodes at this point
                      if(option.nodeType !== 1) continue;

                      // lets build a list item
                      var listItem = document.createElement('li');

                      // we loop through the properties of the node and
                      // apply only the ones that also exist as atributes
                      for(var i in option) {
                        if(option.hasAttribute(i)) listItem.setAttribute(i, option.getAttribute(i));
                      }

                      // loop through the select children to append to the
                      // list item.  We want text nodes this time.
                      while(option.firstChild) {
                        listItem.appendChild(option.firstChild);
                      }

                      // append them to the document fragment for easier
                      // appending later
                      docFrag.appendChild(listItem);
                    }

                    // build wrapping ul.  Same as above
                    for(var i in parent) {
                      if(parent.hasAttribute(i)) list.setAttribute(i, parent.getAttribute(i));
                    }

                    // add the list items to the list
                    list.appendChild(docFrag);

                    // lastly replace the select node with the list
                    parent.parentNode.replaceChild(list, parent);    
              }

            $('.fpvFaster-site-header-currency').css("visibility", "visible");

        //       $('#fpvFaster-new-shopify-currency-form-ul').attr('class', 'shopify-currency-form');

                var $box = $('.fpvFaster-site-header-currency');
                var $option = $('ul#fpvFaster-new-shopify-currency-form-ul', $box);
                var $txt = $('div.fpvFaster-site-header-currency__select-text', $box);

                var speed = 10;
                var $bg = $('b.fpvFaster-site-header-currency__bg',$box);
              // click triangle
              $bg.click(function(){
                  $option.not($(this).siblings('ul#fpvFaster-new-shopify-currency-form-ul')).slideUp(speed, function () {

                  });
                  $(this).siblings('ul#fpvFaster-new-shopify-currency-form-ul').slideToggle(speed, function () {
                    // int($(this));
                  });
                  return false;
                });
               /*
                 * click one list item, toggle the ul list
                 */
                $txt.click(function (e) {

                  $option.not($(this).siblings('ul#fpvFaster-new-shopify-currency-form-ul')).slideUp(speed, function () {

                  });
                  $(this).siblings('ul#fpvFaster-new-shopify-currency-form-ul').slideToggle(speed, function () {
                    // int($(this));
                  });

                  return false;
                });

              //click to select，and close the dropdown list
                  $option.find('li').each(function(index,element){

                    $(this).html(`<span>
                                   <img src="https://cdn.shopify.com/s/files/1/1762/4057/t/212/assets/${$(this).attr("value")}.png" id="flags" >
                                  </span>${$(this).text()}`)
                    if($(this).hasClass('selected')){
                      $(this).parent('#fpvFaster-new-shopify-currency-form-ul').siblings('.fpvFaster-site-header-currency__select-text').html(`<span>
                                            <img src="https://cdn.shopify.com/s/files/1/1762/4057/t/212/assets/${currencyCode}.png" class="fpvFaster-site-header-currency__select-text__flag" id="flags" >
                        </span>${$(this).text()}`);

                    }

                    $(this).mousedown(function(){
                      $(this).parent().siblings('div.fpvFaster-site-header-currency__select-text').html(`<span>
                        <img src="https://cdn.shopify.com/s/files/1/1762/4057/t/212/assets/${currencyCode}.png" class="fpvFaster-site-header-currency__select-text__flag" id="flags" >
                        </span>${$(this).text()}`)
                      .attr('value', $(this).attr('data-option'));
                        $option.slideUp(speed, function () {
                        });
                        $(this).addClass('selected').siblings('li').removeClass('selected');

                       $(this).parent().siblings('div.fpvFaster-site-header-currency__select-text').html(`<span>
                          <img src="https://cdn.shopify.com/s/files/1/1762/4057/t/212/assets/${$(this).attr('value')}.png" class="fpvFaster-site-header-currency__select-text__flag" id="flags" >
                          </span>${$(this).text()}`);

                      $option.parents('form').append(`<select style="position:absolute !important; left:-1000px !important; height:0 !important;width:0 !important; overflow:hidden !important;" name="currency"><option value="${$(this).attr('value')}" selected="true">${$(this).attr('value')}</option></select>`);

                      $(".shopify-currency-form select")
                      .parents('form')
                      .submit();

                        return false;


                    });

                    $(this).on('mouseover',function(){
                      $(this).addClass('selected').siblings('li').removeClass('selected');

                    });
                  });

              // click list item, hide the dropdown list
                $(document).click(function (e) {
                  $option.slideUp(speed, function () {
                  });

                });

            $('.fpvFaster-site-header-currency').css("visibility", "visible !important");
      }
         
    
        
             $('.shopify-currency-form').css("visibility", "visible");

              GeoTools.getGeo(function(geoData) {

                 var currency =  localStorage.getItem('fpvFaster-currency');
                 var countryCurrency=$(".shopify-currency-form select option:selected").val();

                 if((currency === null || currency === undefined )&& $(".shopify-currency-form select option:selected").val() === geoData.currencyCode){
                   $(`.shopify-currency-form select option:contains(${geoData.countryCode})`).prop('selected',true).parents('form').submit();
                   var value = $(`.shopify-currency-form select option:contains(${geoData.countryCode})`).text();
                   localStorage.setItem("fpvFaster-currency", value);
                   
                   if($(".shopify-currency-form").find(".fpvFaster-site-header-currency__select-text").length === 0){
                      $('.shopify-currency-form').append(`
                                  <div class="fpvFaster-site-header-currency__select-text" value=""> 
                                      <span>
                                          <img src="https://cdn.shopify.com/s/files/1/1762/4057/t/212/assets/${geoData.currencyCode}.png" class="fpvFaster-site-header-currency__select-text__flag" id="flags" >
                                      </span>
                                      ${value}
                                  </div>
                                  <b class="fpvFaster-site-header-currency__bg"></b>`
                                  );
                   }


                 }else {
                   if($(".shopify-currency-form").find(".fpvFaster-site-header-currency__select-text").length === 0){
                      $('.shopify-currency-form').append(`
                                  <div class="fpvFaster-site-header-currency__select-text" value=""> 
                                      <span>
                                          <img src="https://cdn.shopify.com/s/files/1/1762/4057/t/212/assets/${countryCurrency}.png" class="fpvFaster-site-header-currency__select-text__flag" id="flags" >
                                      </span>
                                      ${countryCurrency}
                                  </div>
                                  <b class="fpvFaster-site-header-currency__bg"></b>`
                                  );
                   }

                 }
                reRenderSelectElement(countryCurrency);

              });
    
   		 }
    
    }
    
  }
}

var GeoTools = (function(){
  var self = this;
  var geoData = null;
  var httpInProgress = false;
  var callbacks = [];
  
  return {
    getGeo: function(callback) {
      if (!geoData) {
        callbacks.push(callback);
        if (!httpInProgress) {
          httpInProgress = true;
          $.getJSON("https://ssl.geoplugin.net/json.gp?k=70843982b537653f&jsoncallback=?", function(data){
            geoData = {
              ip: data.geoplugin_request,
              countryCode: data.geoplugin_countryCode,
              countryName: data.geoplugin_countryName,
              stateCode: data.geoplugin_regionCode,
              stateName: data.geoplugin_regionName,
              city: data.geoplugin_city,
              latitude: data.geoplugin_latitude,
              longitude: data.geoplugin_longitude,
              locationAccuracyRadius: data.geoplugin_locationAccuracyRadius,
              timezone: data.geoplugin_timezone,
              currencyCode: data.geoplugin_currencyCode,
              currencySymbol: data.geoplugin_currencySymbol,
              currencySymbolUtf8: data.geoplugin_currencySymbol_UTF8,
              currencyUsdToSelf: data.geoplugin_currencyConverter
            }

            for (var i = 0; i < callbacks.length; i++) {
              callbacks[i](geoData);
            }
            callbacks = [];
          })
            .always(function() {
            httpInProgress = false;
          });
        }
      } else {
          callback(geoData)
      }
    }
  };
})();

(function(){
  GeoTools.getGeo(function(geoData) {
    if(geoData.countryCode === "AU") {
      $(".product-delivery").show();
    } else {
      $(".delivery-est-intl").show();
      $(".btn-lipo-add-to-cart").hide();
    }
  });
  
  $(document).ready(function() {
    mns = "main-nav-scrolled";
    hdr = $('header').height();
    var mn = $("#menuScroll");

    if ($(window).width() > 800) {
      mn = $("#menuScroll");
    } else {
      mn = $("#mobileNavBar");
    }

    windowWidth = $(window).width();
    $(window).resize(function() {
      windowWidth = $(window).width();
      if (windowWidth > 800) {
        mn = $("#menuScroll");
      } else {
        mn = $("#mobileNavBar");
      }
    });

    var $fsb_container;
    var $fsb_bg;
    shippingBarHeight = 0
    $(window).scroll(function() {
      if (!$fsb_container || !$fsb_container.length) {
        $fsb_container = $('#fsb_container')
      }
      
      if (!$fsb_bg || $fsb_bg.length) {
        $fsb_bg = $('#fsb_background')
      }
    
      GeoTools.getGeo(function(geoData) {
        if(geoData.countryCode === "AU") {
          if (this.shippingBarHeight) {
          } else if ($fsb_container.css('display') === "block" && $fsb_bg.css("top") === "0px") {
            this.shippingBarHeight = $fsb_container.height();
          }
        } else {
          this.shippingBarHeight = 0
          $fsb_container.hide();
          $fsb_bg.hide();
        }
      });

      if (windowWidth > 800) {
        if($(this).scrollTop() > hdr) {
          mn.addClass(mns);
          mn.css("top", shippingBarHeight);
        } else {
          mn.removeClass(mns);
        }
      } else {
        //           mn.css("top", shippingBarHeight);
        //           $("#shopify-section-header").css("padding-top", shippingBarHeight);
      }
    });
  });
})();